<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && (!header || !header.length)"
         align="center"
         class="headline mb-5">
      Nenhuma resposta encontrada
    </div>
    <v-simple-table
      v-if="!loading && header && header.length"
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">-</th>
          <template v-if="isTipoProduto">
            <th class="text-center" v-for="column in header" :key="column.id">
              {{ column.pessoa.nome }}
              <px-negociacao-modal
                v-if="hasModuleGerencia"
                :resposta="respostaFornecedor(column)">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-handshake</v-icon>
                  </v-btn>
                </template>
              </px-negociacao-modal>
            </th>
          </template>
          <template v-else>
            <th class="text-center" v-for="column in header" :key="column.id">
              <template v-if="!column.especificacaoProduto">
                <px-span-tooltip v-if="checkCodigo(column.produto)"
                                 top
                                 :text="labelCodigo(column.produto)"
                                 tooltip="Código interno"/>
                {{ column.produto.descricao }}
                <px-historico-preco-produto small
                                            :produto="column.produto"
                                            :unidade-medida="column.produto.unidadeMedida"/>
              </template>
              <template v-else>
                <px-span-tooltip
                  v-if="checkCodigo(column.produto)"
                  top
                  :text="`${labelCodigo(column.produto)} ${column.produto.descricao}`"
                  :tooltip="column.especificacaoProduto"/>
                <px-span-tooltip v-else top
                                 :text="column.produto.descricao"
                                 :tooltip="column.especificacaoProduto"/>
                <px-historico-preco-produto small
                                            :produto="column.produto"
                                            :unidade-medida="column.produto.unidadeMedida"/>
              </template>
              <div v-if="showEspecificacao" class="caption">
                {{ column.especificacaoProduto | truncate(50) }}
              </div>
            </th>

          </template>
          <th>
            <px-carrinho-matriz
              v-if="hasModuleGerencia"
              :produtos="produtos"
              @update="onUpdate">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>
                    mdi-cart
                  </v-icon>
                </v-btn>
              </template>
            </px-carrinho-matriz>
          </th>
        </tr>
        </thead>
        <tbody>
        <template v-if="isTipoProduto">
          <tr v-for="produtoFornecedor in produtosGrid" :key="produtoFornecedor.id">
            <td class="text-center">
              <px-span-tooltip
                v-if="checkCodigo(produtoFornecedor.produto.cotacaoProduto.produto)"
                top
                :text="labelCodigo(produtoFornecedor.produto.cotacaoProduto.produto)"
                tooltip="Código interno"/>
              {{ produtoFornecedor.produto.cotacaoProduto.produto.descricao }}
              <px-situacao-cotacao-icon
                :situacao="produtoFornecedor.produto.cotacaoProduto.situacao"/>
              <px-historico-preco-produto
                small
                :produto="produtoFornecedor.produto.cotacaoProduto.produto"
                :unidade-medida="produtoFornecedor.produto.cotacaoProduto.produto.unidadeMedida"/>
              <div v-if="showEspecificacao" class="caption">
                {{ produtoFornecedor.produto.cotacaoProduto.especificacaoProduto | truncate(50) }}
              </div>
            </td>
            <td class="text-center"
                v-for="fornecedorProduto in produtoFornecedor.fornecedores"
                :key="fornecedorProduto.id">
              <px-matriz-item :has-preco="hasPreco"
                              :has-prazo="hasPrazo"
                              :has-frete="hasFrete"
                              :hide-icms="showPrecoSemIcms"
                              :has-especificacao="showEspecificacaoFornecedor"
                              :show-percentual-icms="showPercentualIcms"
                              :show-preco-target="showPrecoTarget"
                              :produto="fornecedorProduto"/>
            </td>
            <td>
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-center">
              Total
            </td>
            <td class="text-center" v-for="resposta in respostasTotais" :key="resposta.id">
              {{ resposta.valorMoedaConvertido.total | currency('R$', getCasasDecimais(resposta)) }}
            </td>
            <td></td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="fornecedor in fornecedores" :key="fornecedor.id">
            <td class="text-center">
              {{ fornecedor.fornecedor.pessoa.nome | truncate(25) }}
            </td>
            <td class="text-center" v-for="produto in fornecedor.produtos" :key="produto.id">
              <px-matriz-item :has-preco="hasPreco"
                              :has-prazo="hasPrazo"
                              :has-frete="hasFrete"
                              :hide-icms="showPrecoSemIcms"
                              :has-especificacao="showEspecificacaoFornecedor"
                              :show-percentual-icms="showPercentualIcms"
                              :show-preco-target="showPrecoTarget"
                              :produto="produto"/>
            </td>
            <td>
              <px-negociacao-modal
                v-if="hasModuleGerencia"
                :resposta="respostaFornecedor(fornecedor.fornecedor)">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-handshake</v-icon>
                  </v-btn>
                </template>
              </px-negociacao-modal>
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td class="text-center">
              Total
            </td>
            <td class="text-center" v-for="resposta in respostasTotais" :key="resposta.id">
              {{ resposta.total | currency('R$', getCasasDecimais(resposta)) }}
            </td>
            <td></td>
          </tr>
        </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import { CasaDecimalUtils } from 'px-components';
import { mapGetters, mapActions } from 'vuex';
import { GET_ITENS } from '@/store/carrinho/actions.type';
import {
  groupBy, minBy, first, uniqBy, map, orderBy, find, isEmpty,
} from 'lodash';
import currency from 'currency.js';
import { setMelhorPrazoPagamento, setMelhorFrete } from './matriz-utils';
import MatrizService from './matriz-service';
import PxMatrizItem from './PxMatrizItem.vue';
import CarrinhoMatriz from './carrinho/CarrinhoMatriz.vue';
import NegociacaoModal from '../negociacao/modal/NegociacaoModal.vue';

const TIPO_MATRIZ = {
  PRODUTO: 'PRODUTO',
  FORNECEDOR: 'FORNECEDOR',
};

export default {
  data() {
    return {
      respostas: null,
      produtos: null,
      header: null,
      fornecedores: null,
      produtosGrid: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('matriz', ['cotacoes', 'viewType', 'stringFilter', 'cotacoesItens', 'showEspecificacao', 'showEspecificacaoFornecedor', 'showPrecoSemIcms', 'tipoVisualizacao', 'showPercentualIcms', 'showPrecoTarget']),
    ...mapGetters('user', ['hasModuleGerencia']),
    hasPreco() {
      return this.viewType && this.viewType.includes('PRECO');
    },
    hasPrazo() {
      return this.viewType && this.viewType.includes('FORMA_PAGAMENTO');
    },
    hasFrete() {
      return this.viewType && this.viewType.includes('FRETE');
    },
    respostaFornecedor() {
      return fornecedor => this.respostas.find(r => r.fornecedor.id === fornecedor.id);
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `(${item.codigo})`;
    },
    isTipoProduto() {
      return this.tipoVisualizacao === 'PRODUTO';
    },
    respostasTotais() {
      return orderBy(this.respostas, 'fornecedor.id');
    },
    getCasasDecimais() {
      return (resposta) => {
        const produtos = resposta.produtos.map(p => p.cotacaoProduto.produto);
        return CasaDecimalUtils.getCasaDecimal(produtos);
      };
    },
  },
  methods: {
    ...mapActions('carrinho', {
      getItens: GET_ITENS,
    }),
    buildCotacoesParam() {
      if (!this.cotacoes || !this.cotacoes.length) {
        return [];
      }
      return this.cotacoes.map(cot => cot.id)
        .join(',');
    },
    updateRespostas() {
      this.getRespostas();
    },
    onUpdate() {
      this.getItens();
    },
    filterItensProdutos(data) {
      if (isEmpty(this.cotacoesItens) || !data) {
        return data;
      }
      const ids = this.cotacoesItens.map(item => item.id);
      return data.map((resp) => {
        const resposta = { ...resp };
        resposta.produtos = resposta.produtos.filter(prod => ids.includes(prod.cotacaoProduto.id));
        return resposta;
      });
    },
    getRespostas() {
      this.loading = true;
      MatrizService.getRespostas({
        cotacoes: this.buildCotacoesParam(),
        query: this.stringFilter,
      })
        .then(({ data }) => {
          this.respostas = this.filterItensProdutos(data);
          this.buildProdutos();
          this.setMelhorPreco();
          setMelhorPrazoPagamento(this.produtos);
          setMelhorFrete(this.produtos);
          this.buildHeader();
          this.buildFornecedores();
          this.buildProdutosGrid();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildPrecoSemIcms(produto) {
      if (!produto.impostos.icms) {
        return produto.valorMoedaConvertido.precoUnitario;
      }

      const valorIcms = currency(produto.valorMoedaConvertido.precoUnitario)
        .multiply(produto.impostos.icms);

      return currency(produto.valorMoedaConvertido.precoUnitario)
        .subtract(valorIcms).value;
    },
    buildProdutos() {
      const produtos = [];
      this.respostas.forEach((resposta) => {
        resposta.produtos.forEach((produto) => {
          const item = {
            produto: {
              ...produto,
              precoSemIcms: this.buildPrecoSemIcms(produto),
            },
            situacao: produto.cotacaoProduto.situacao,
            fornecedor: resposta.fornecedor,
            formaPagamento: resposta.formaPagamento,
            prazoPagamento: resposta.prazoPagamento,
            frete: resposta.frete,
          };
          produtos.push(item);
        });
      });
      this.produtos = produtos;
    },
    resetProdutosMelhorPreco(produtos) {
      return produtos.forEach((produto) => {
        // eslint-disable-next-line no-param-reassign
        produto.$melhorPreco = false;
      });
    },
    setMelhorPreco() {
      const grupos = groupBy(this.produtos, 'produto.cotacaoProduto.id');
      Object.keys(grupos)
        .forEach((key) => {
          const produtos = grupos[key]
            .filter(prod => prod.produto.valorMoedaConvertido.precoUnitario > 0);
          this.resetProdutosMelhorPreco(produtos);
          const precoField = this.showPrecoSemIcms ? 'produto.precoSemIcms' : 'produto.valorMoedaConvertido.precoUnitario';
          const cheaper = minBy(produtos, precoField);
          if (!cheaper) {
            return;
          }
          cheaper.$melhorPreco = true;
        });
    },
    buildHeader() {
      if (this.tipoVisualizacao === TIPO_MATRIZ.PRODUTO) {
        const fornecedores = uniqBy(this.produtos, 'fornecedor.id');
        this.header = orderBy(map(fornecedores, 'fornecedor'), 'id');
        return;
      }
      const produtos = uniqBy(this.produtos, 'produto.cotacaoProduto.id');
      this.header = orderBy(map(produtos, 'produto.cotacaoProduto'), 'id');
    },
    buildFornecedores() {
      const fornecedores = groupBy(this.produtos, 'fornecedor.id');
      this.fornecedores = map(fornecedores, this.mapFornecedores);
    },
    buildProdutosGrid() {
      const produtos = groupBy(this.produtos, 'produto.cotacaoProduto.id');
      this.produtosGrid = map(produtos, this.mapProdutos);
    },
    mapProdutos(produtos) {
      const result = {
        produto: first(produtos).produto,
      };
      result.fornecedores = this.header.map((fornecedor) => {
        const found = find(produtos, toFind => toFind.fornecedor.id === fornecedor.id);
        if (!found) {
          return this.createProduto(fornecedor, result.produto.cotacaoProduto);
        }
        return found;
      });
      result.fornecedores = orderBy(result.fornecedores, 'fornecedor.id');
      return result;
    },
    mapFornecedores(forn) {
      const result = {
        fornecedor: first(forn).fornecedor,
      };
      result.produtos = this.header.map((prod) => {
        const found = find(forn, toFind => toFind.produto.cotacaoProduto.id === prod.id);
        if (!found) {
          return this.createProduto(result.fornecedor, prod);
        }
        return found;
      });
      result.produtos = orderBy(result.produtos, 'produto.cotacaoProduto.id');
      return result;
    },
    createProduto(fornecedor, cotacaoProduto) {
      return {
        formaPagamento: null,
        prazoPagamento: null,
        fornecedor,
        produto: {
          precoUnitario: null,
          cotacaoProduto,
          situacao: SituacaoRespostaCotacaoProduto.keys.NAO_RESPONDIDA.key,
        },
      };
    },
  },
  watch: {
    showPrecoSemIcms(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setMelhorPreco();
    },
    tipoVisualizacao(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getRespostas();
    },
  },
  created() {
    this.getRespostas();
  },
  components: {
    PxMatrizItem,
    PxNegociacaoModal: NegociacaoModal,
    PxCarrinhoMatriz: CarrinhoMatriz,
  },
};
</script>
